import { Button } from "primereact/button"

const CustomButton = ({
  className,
  children,
  onClick,
  disabled = false,
  type = "button",
  loading = false,
  tooltip,
  style,
  ...props
}: $TSMigrationFixMe) => {
  return (
    <Button
      style={style}
      loading={loading}
      onClick={onClick}
      tooltip={tooltip}
      className={`${className} button`}
      type={type}
      disabled={disabled}
      {...props}
    >
      {!loading && children}
    </Button>
  )
}

export default CustomButton
